import { useContext } from "react";

import { IPermissionsContext, PermissionsContext } from "./PermissionsContext";

export function usePermissions(): IPermissionsContext {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }

  return context;
}
